<template>
    <div >
        <div class="items-list"><router-view /></div>
        <div class="items" :style="{'width': withItems +'px'}">
            <div class="item" :class="{'active': item === 'estudio'}" @click="$router.push({name: 'estudio'})">
                Estudio
            </div>
            <div class="item" :class="{'active': item === 'chaturbate'}" @click="$router.push({name: 'chaturbate'})">
                Chaturbate
            </div>
            <div class="item" :class="{'active': item === 'stripchat'}" @click="$router.push({name: 'stripchat'})">
                Stripchat
            </div>
            <div class="item" :class="{'active': item === 'bongacams'}" @click="$router.push({name: 'bongacams'})">
                BongaCams
            </div>
            <div class="item" :class="{'active': item === 'camsoda'}" @click="$router.push({name: 'camsoda'})">
                CamSoda
            </div>
            <div class="item" :class="{'active': item === 'skyprivate'}" @click="$router.push({name: 'skyprivate'})">
                SkyPrivate
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'items',
    data() {
        return {
            withItems: window.innerWidth - 350,
            item: null,
            modelName: null
        }
    },
    mounted() {
        this.item = this.$route.name
        if (!this.$store.state.constants.COLLAPSE) {
            this.withItems = window.innerWidth - 80
        } else {
            this.withItems = window.innerWidth - 350
        }
        this.$root.$on('collapse', (block) => {
            if (block) {
                this.withItems = window.innerWidth - 350
            } else {
                this.withItems = window.innerWidth - 80
            }
        })
        this.$root.$on('changePlatform', (block) => {
            this.item = block
        })
    }
}
</script>

<style scoped>
    .items {
        position: fixed;
        text-align: center;
        display: flex;
        transition: width 1s;
    }
    .item {
        background-color: #e0b059;
        width: 20%;
        padding: 20px;
        color: #fff;
        font-weight: bolder;
        border-style: outset;
        min-height: 12vh;
    }
    .active{
        border-style: inset;
        background-color: #fff;
        color: #e0b059;
    }
    .item:hover {
        border-style: double;
        border-color: black;
    }
    .items-list {
       width: 100%;
       min-height: 78vh;
    }
    .back-arrow {
        position: fixed;
        background-color: #e0b059;
        font-size: 28px;
        border-radius: 50%;
        border-style: outset;
        padding: 10px;
        right: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Reportes/Plataformas/Items.vue